// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'layout';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M2.625 1.56h12.75s1.063 0 1.063 1.063v12.75s0 1.062-1.063 1.062H2.625s-1.063 0-1.063-1.062V2.623s0-1.063 1.063-1.063zM1.563 5.81h14.874M6.875 16.435V5.81'
  />
);

export const viewBox = '0 0 18 18';
